module.exports = __webpack_public_path__ + "img/IMG_9543_L_Wood.e87dd51f.jpg";